import axios from 'axios'

const state = {
  debugValues: []
}

const actions = {
  setDebugState ({commit}, data) {
    commit('setDebugValues', data)
  }
}

const mutations = {
  setDebugValues (state, data) {
    const date = new Date().toLocaleTimeString([], { hour: '2-digit', minute: "2-digit", second: "2-digit", hour12: false })

    state.debugValues = !data ? state.debugValues : [...state.debugValues, { Id: Date.now(), Value: date, Items: data}]
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
